import {
  GET_ACCOUNT
} from 'src/store/mutation-types'

export default {
  [GET_ACCOUNT] (state, accountInfo) {
    state.accountInfo = accountInfo
  }
}



// WEBPACK FOOTER //
// ./src/components/account/store/mutations.js